import React from 'react';
import useEpisodePlayersContext from '../../../hooks/useEpisodePlayersContext';
import usePlayersContext from '../hooks/usePlayersContext';

const Image = () => {
    const { data } = useEpisodePlayersContext();
    const { episodeIndex } = usePlayersContext();
    const { podcastImageUrl } = data;
    const { episodeTitle } = data.episodes[episodeIndex];
    const podcastData = data.episodes[episodeIndex];
    const imageUrl = podcastImageUrl ?? podcastData?.podcastImageUrl;
    const alt = (data?.podcastImageAlt ?? data.episodes[episodeIndex]?.podcastImageAlt) || episodeTitle;

    if (!imageUrl) {
        return null;
    }

    return (
        <img
            height={80}
            width={80}
            src={imageUrl}
            alt={alt ? alt : 'Featured Episode'}
        />
    );
};

export default Image;
